import { useCallback, useState } from 'react';

// returning a new object reference guarantees that a before-and-after
// equivalence check will always be false, resulting in a re-render,
// even when multiple calls to forceUpdate are batched
export const useForceUpdate = (): (() => void) => {
  // eslint-disable-next-line react/hook-use-state
  const [, dispatch] = useState(Object.create(null));

  // turn dispatch(required_parameter) into dispatch()
  return useCallback(() => {
    dispatch(Object.create(null));
  }, [dispatch]);
};
